import {defineStore} from 'pinia'
import {ref, computed} from 'vue'


// 在创建 store 之前，确保 pinia 实例已注册持久化插件
export const useWuliu178AuthStore = defineStore(
    'wl_auth',
    () => {
        // state

        const isLoggedIn = ref(false)
        // 从 access_token 中解析用户信息（payload）与过期时间
        const userInfo = computed(() => {
            if (!access_token.value) return null;
            try {
                // JWT 由 header.payload.signature 三段组成，取第二段
                const payload = access_token.value.split('.')[1];
                // base64Url -> base64 -> JSON
                const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
                return JSON.parse(json);
            } catch {
                return null;
            }
        });

        // 过期时间（秒级时间戳）
        const expireAt = computed(() => userInfo.value?.exp || null);

        // 是否已过期
        const isExpired = computed(() => {
            if (!expireAt.value) return true;
            // 提前 30 秒视为过期，避免临界请求失败
            return Date.now() >= (expireAt.value - 30) * 1000;
        });
        const access_token = ref(null)
        const refresh_token = ref(null)
        const rememberMe = ref(false)

        // 用户菜单权限列表
        const menuPermissions = ref([])
        // 用户详细信息
        const userProfile = ref(null)


        // actions
        function login(data) {
            access_token.value = data.access_token;
            refresh_token.value = data.refresh_token;
            rememberMe.value = data.rememberMe;
            isLoggedIn.value = true;
        }

        function logout() {
            access_token.value = null;
            refresh_token.value = null;
            // 主动登出的时候，需要清除rememberMe
            rememberMe.value = false;
            isLoggedIn.value = false;
            // 清除菜单权限和用户信息
            menuPermissions.value = [];
            userProfile.value = null;
        }

        // 设置用户菜单权限
        function setMenuPermissions(permissions) {
            menuPermissions.value = permissions || [];
        }

        // 设置用户详细信息
        function setUserProfile(profile) {
            userProfile.value = profile;
            // 同时设置菜单权限
            if (profile && profile.menu_permissions) {
                menuPermissions.value = profile.menu_permissions;
            }
        }

        // 检查是否有某个菜单权限
        function hasMenuPermission(permissionCode) {
            if (!menuPermissions.value || menuPermissions.value.length === 0) {
                return false;
            }
            return menuPermissions.value.includes(permissionCode);
        }

        return {
            access_token,
            refresh_token,
            isLoggedIn,
            rememberMe,
            userInfo,
            expireAt,
            isExpired,
            menuPermissions,
            userProfile,
            login,
            logout,
            setMenuPermissions,
            setUserProfile,
            hasMenuPermission
        }
    },


    {
        // 持久化配置
        persist:
            true,
        // {
        // key: 'jwt',
        // storage: localStorage,
        // paths: []
        // }
    }
)
